import React from "react";
import { projects } from "../data";

export default function Projects() {
  return (
    <section id="projects" className="text-gray-600 bg-white body-font">
      <div className="container px-5 py-16 mx-auto max-w-6xl text-center">
        <div className="flex flex-col w-full mb-10">
          <h1 className="text-4xl sm:text-5xl font-bold title-font mb-4 text-gray-900">
            Our Work
          </h1>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-base sm:text-lg md:text-xl">
            Selected apps and demos that show how we build, from idea to
            shipped product.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project) => (
            <a
              href={project.link}
              key={project.image}
              className="block transform transition duration-300 hover:scale-105"
            >
              <div className="relative rounded-xl overflow-hidden shadow-lg border border-gray-200">
                <img
                  alt="gallery"
                  className="w-full h-auto object-cover"
                  src={project.image}
                />
                <div className="absolute inset-0 bg-purple-900 bg-opacity-90 opacity-0 hover:opacity-100 flex flex-col justify-center items-center text-center transition duration-300 p-4">
                  <h2 className="tracking-widest text-sm title-font font-medium text-purple-300 mb-1">
                    {project.subtitle}
                  </h2>
                  <h1 className="title-font text-lg font-medium text-white mb-3">
                    {project.title}
                  </h1>
                  <div className="flex flex-wrap justify-center gap-1.5 mb-3">
                    {project.tags.map((tag) => (
                      <span
                        key={tag}
                        className="text-xs bg-purple-800 text-purple-100 border border-purple-700 rounded-full px-2 py-0.5"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <p className="leading-relaxed px-4 text-purple-100">
                    {project.description}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
